module.exports = __webpack_public_path__ + "static/media/adherence.78cc01ba.svg";